// extracted by mini-css-extract-plugin
module.exports = {"Main":"Home_Main__orkx_","MainImage":"Home_MainImage___rrK1"};